import React from 'react';

const HomePage = React.lazy(() => import('./HomePage' /* webpackChunkName: "Home" */));
export default function HomeInitializer() {
    return <HomePage />;
}
